import { useTranslation } from 'react-i18next';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

export default function Contact() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-32 pb-16">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-16">
            <h1 className="text-3xl md:text-4xl font-light tracking-wider text-gray-800 uppercase mb-8">
              {t('getInTouch')}
            </h1>
            <div className="space-y-4 text-lg font-light tracking-wide text-gray-800">
              <p>
                <a 
                  href="mailto:Pedrofaerstein@gmail.com" 
                  className="hover:text-gray-500 transition-colors cursor-pointer"
                >
                  Pedrofaerstein@gmail.com
                </a>
              </p>
              <p>
                <a 
                  href="https://www.instagram.com/Pedrofaerstein" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-gray-500 transition-colors cursor-pointer"
                >
                  @Pedrofaerstein
                </a>
              </p>
              <p>
                <a 
                  href="https://wa.me/5521988870070" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-gray-500 transition-colors cursor-pointer"
                >
                  +55 21 98887-0070
                </a>
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
